import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-239e1609"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("LnwSaving")
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, [
  /*#__PURE__*/_createElementVNode("i", null, "(Remastered)")
], -1))
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Sign in")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Force reload ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" วิธีใช้ / ช่วยเหลือ ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_list_header = _resolveComponent("ion-list-header")!
  const _component_ion_note = _resolveComponent("ion-note")!
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_menu_toggle = _resolveComponent("ion-menu-toggle")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_menu = _resolveComponent("ion-menu")!
  const _component_ion_router_outlet = _resolveComponent("ion-router-outlet")!
  const _component_IonSplitPane = _resolveComponent("IonSplitPane")!
  const _component_IonApp = _resolveComponent("IonApp")!

  return (_openBlock(), _createBlock(_component_IonApp, null, {
    default: _withCtx(() => [
      _createVNode(_component_IonSplitPane, { "content-id": "main-content" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_menu, {
            "content-id": "main-content",
            type: "overlay",
            swipeGesture: _ctx.iOnMenuSwipeGesture
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_content, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_list, { id: "inbox-list" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_list_header, null, {
                        default: _withCtx(() => [
                          _hoisted_1
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_note, null, {
                        default: _withCtx(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      }),
                      (_ctx.$store.getters['auth/isLoggedIn'])
                        ? (_openBlock(), _createBlock(_component_ion_item, {
                            key: 0,
                            lines: "none"
                          }, {
                            default: _withCtx(() => [
                              (
                    _ctx.$store.state.auth.currentUser &&
                      _ctx.$store.state.auth.currentUser.avatar
                  )
                                ? (_openBlock(), _createBlock(_component_ion_avatar, {
                                    key: 0,
                                    slot: "start"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("img", {
                                        src: _ctx.$store.state.auth.currentUser.avatar,
                                        alt: "avatar"
                                      }, null, 8, _hoisted_3)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$store.state.auth.currentUser.name) + " ", 1),
                                  _createElementVNode("p", {
                                    class: _normalizeClass({'notSelectedSave':!_ctx.currentSaveName})
                                  }, _toDisplayString(_ctx.currentSaveName ? _ctx.currentSaveName : "ยังไม่ได้เลือกแฟ้ม"), 3)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.$store.getters['auth/isLoggedIn'])
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.appPages, (p, i) => {
                            return (_openBlock(), _createBlock(_component_ion_menu_toggle, {
                              "auto-hide": "false",
                              key: i
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_item, {
                                  "router-direction": "root",
                                  "router-link": p.url,
                                  lines: "none",
                                  detail: "false",
                                  class: _normalizeClass(["hydrated", { selected: _ctx.selectedIndex === i }])
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_icon, {
                                      slot: "start",
                                      ios: p.iosIcon,
                                      md: p.mdIcon
                                    }, null, 8, ["ios", "md"]),
                                    _createVNode(_component_ion_label, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(p.title), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["router-link", "class"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        : (_openBlock(), _createBlock(_component_ion_menu_toggle, {
                            key: 2,
                            "auto-hide": "false"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_item, {
                                "router-direction": "root",
                                "router-link": { name: 'login' },
                                lines: "none",
                                detail: "false",
                                class: "hydrated"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "start",
                                    ios: _ctx.iconLoginOutline,
                                    md: _ctx.iconLoginSharp
                                  }, null, 8, ["ios", "md"]),
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _hoisted_4
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_footer, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_grid, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_button, {
                                size: "small",
                                color: "light",
                                fill: "solid",
                                onClick: _ctx.hardReload
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "start",
                                    icon: _ctx.iconReload,
                                    style: {"font-size":"100%"}
                                  }, null, 8, ["icon"]),
                                  _hoisted_5
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_col, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_menu_toggle, { "auto-hide": "false" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_button, {
                                    size: "small",
                                    color: "tertiary",
                                    fill: "solid",
                                    "router-direction": "root",
                                    "router-link": { name: 'help' }
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "start",
                                        ios: _ctx.helpOutline,
                                        md: _ctx.helpSharp,
                                        style: {"font-size":"110%"}
                                      }, null, 8, ["ios", "md"]),
                                      _hoisted_6
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["swipeGesture"]),
          _createVNode(_component_ion_router_outlet, {
            ref: "routerOutlet",
            id: "main-content",
            swipeGesture: "false"
          }, null, 512)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}